import PropTypes from 'prop-types'

import Button from '../../../Theme/Button'
import FAIcon from '../../../Theme/FAIcon'
import { FA_ICONS } from '../../../Theme/font-awesome-icon-constants'

const ButtonUnFollow = ({ text = 'Unfollow', iconRight = false, ...rest }) => (
  <Button
    variant="contained"
    color="inherit"
    sx={{ gap: '16px' }}
    {...rest}
  >
    {iconRight && !!text && text}
    <FAIcon
      iconFontSize={16}
      iconClassName={FA_ICONS.USER_MINUS}
    />
    {!iconRight && !!text && text}
  </Button>
)

ButtonUnFollow.propTypes = {
  text: PropTypes.string,
  iconRight: PropTypes.bool,
}

export default ButtonUnFollow
